import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { YSButton } from "../../../uikit/YSButton";
import { useEffect, useState } from "react";
import { FieldArray, Form, Formik } from "formik";
import {
  greyColor,
  BtnSMGroupStyle,
  DRxInputStyle,
  DRxSelectStyle,
  ContentStyle,
  AlertInfo,
} from "../../../Theme";
import { useLocation, useNavigate } from "react-router";
import YSCheckBox from "../../../uikit/YSCheckBox";
import DRxInput from "../../../uikit/DRxInput";
import AlertInfoIcon from "../../../images/icons/AlertInfoIcon.svg";
import TabsNav from "../../../components/TabsNav";
import YSSnackBar from "../../../uikit/YSSnackBar";
import DRxSelect from "../../../uikit/DRxSelect";
import { MedicationHistoryDrugInactive } from "../../../Apis/AuthApiServices";

const inactiveReason = [
  { value: "RX done in error", label: "RX done in error" },
  { value: "Duplicate RX", label: "Duplicate RX" },
  { value: "RX Cancelled", label: "RX Cancelled" },
  { value: "Medication ended", label: "Medication ended" },
  { value: "Obsolete Rx", label: "Obsolete Rx" },
  { value: "Out of refills", label: "Out of refills" },
  { value: "Change of Dosage", label: "Change of Dosage" },
  { value: "Ineffective", label: "Ineffective" },
  { value: "Side Effects", label: "Side Effects" },
];
const initialStateMedicationInactivation: any = {
  selectedMedications: [],
  FreeText: [],
};

export default function MedicationInactivation(props: any) {
  const location: any = useLocation();
  const [data, setData] = useState(initialStateMedicationInactivation);

  const [free, SetFree] = useState(false);

  const [StateData, SetStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });

  const navigate = useNavigate();

  const submitForm = async (formData: any) => {
    const final: any = data.selectedMedications.map((item: any, i: any) =>
      Object.assign({}, item, formData.selectedMedications[i])
    );

    try {
      const doctorId: any = localStorage.getItem("doctorId");
      const patientId: any = sessionStorage.getItem("patientId");
      const submitting = {
        doctorId: doctorId,
        patientId: patientId,
        selectedMedications: final,
      };

      const result = await MedicationHistoryDrugInactive(submitting);
      if (result?.data?.digitalRxStatusCode === 200) {
        SetStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.response[0]?.message,
            variant: "success",
            open: true,
          };
        });
        setTimeout(() => {
          navigate("/medicationshistory");
        }, 2000);
      } else {
        SetStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (err) {
      SetStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again After Some Time!",
          variant: "error",
          open: true,
        };
      });
    }
  };
  const MedicationArray: any = [];
  useEffect(() => {
    location.state.selectedDrugIds.map((eachId: any) => {
      MedicationArray.push({ id: eachId });
      data.FreeText.push(false);
    });
    setData({ ...data, selectedMedications: MedicationArray });
  }, []);
  return (
    <>
      <TabsNav />{" "}
      <ContentStyle>
        <Typography component="h6" color="primary" variant="h6">
          Medication Inactivation
        </Typography>

        <div
          style={{
            overflow: "auto",
            height: "90vh",
          }}
        >
          <Formik
            initialValues={data}
            onSubmit={(values) => {
              submitForm(values);
            }}
          >
            {(registerProps) => (
              <Form>
                <Grid
                  container
                  item
                  xs={12}
                  spacing={0}
                  alignItems="top"
                  justifyContent="space-between"
                  columnSpacing={4}
                  rowSpacing={1}
                >
                  <Grid item xs={3}>
                    <Typography
                      component="div"
                      color={"primary"}
                      variant="body2"
                    >
                      Drug Name
                    </Typography>{" "}
                  </Grid>
                  <Grid item xs={3}>
                    <Typography
                      component="div"
                      color={"primary"}
                      variant="body2"
                    >
                      Reason for inactivation
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography
                      component="div"
                      color={"primary"}
                      variant="body2"
                    >
                      Free text reason
                    </Typography>{" "}
                  </Grid>{" "}
                  <Grid item xs={3}>
                    {location?.state?.selectionData.map((i: any) => (
                      <Box style={{ minHeight: 50 }}>
                        {" "}
                        <Typography
                          component="div"
                          color={greyColor}
                          variant="body2"
                        >
                          {i.description}
                        </Typography>
                      </Box>
                    ))}
                  </Grid>
                  <Grid item xs={3}>
                    <FieldArray name="selectedMedications">
                      {() =>
                        data?.selectedMedications.map(
                          (selectedMed: any, i: any) => {
                            return (
                              <>
                                <Box key={i} style={{ minHeight: 50 }}>
                                  <DRxSelectStyle>
                                    <DRxSelect
                                      id="reason"
                                      disabled={
                                        registerProps.values.FreeText[i]
                                          ? true
                                          : false
                                      }
                                      name={`selectedMedications.${i}.reason`}
                                      label="Reason"
                                      data={inactiveReason}
                                    />
                                  </DRxSelectStyle>
                                </Box>
                              </>
                            );
                          }
                        )
                      }
                    </FieldArray>
                  </Grid>
                  <Grid item xs={6}>
                    <FieldArray name="selectedMedications">
                      {() =>
                        data?.selectedMedications.map(
                          (selectedMed: any, i: any) => {
                            return (
                              <>
                                <Box
                                  key={i}
                                  style={{ minHeight: 50, display: "flex" }}
                                >
                                  <DRxInputStyle
                                    style={{ width: "50%", marginRight: 10 }}
                                  >
                                    <DRxInput
                                      id="FreeTextReason"
                                      name={`selectedMedications.${i}.reason`}
                                      type="text"
                                      className=""
                                      disabled={
                                        registerProps.values.FreeText[i]
                                          ? false
                                          : true
                                      }
                                    />
                                  </DRxInputStyle>
                                  <YSCheckBox
                                    style={{ marginTop: "-5px" }}
                                    label="Use free text"
                                    name={`FreeText[${i}]`}
                                    onChange={() => {
                                      SetFree(!free);
                                      registerProps.setFieldValue(
                                        `FreeText${[i]}`,
                                        !free
                                      );
                                    }}
                                  />{" "}
                                </Box>
                              </>
                            );
                          }
                        )
                      }
                    </FieldArray>
                  </Grid>
                  <Grid item xs={12}>
                    <BtnSMGroupStyle style={{ marginTop: 30 }}>
                      <YSButton
                        size="large"
                        className=""
                        color="primary"
                        dataTestId="submitBtn"
                        variant="contained"
                        disabled={false}
                        type="submit"
                        children={"Submit"}
                        onClick={null}
                      />
                    </BtnSMGroupStyle>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </div>
        <div>
          <Grid item xs={12}>
            <AlertInfo marginBottom={1} marginTop={1}>
              <img src={AlertInfoIcon} alt="Alert" loading="lazy" />
              <Typography color={"error"}>
                Inactivating medications on this screen only inactivates/cancels
                the medication in Digital Rx. No communication is sent to
                pharmacy during this process.
              </Typography>
            </AlertInfo>
          </Grid>
        </div>
        <YSSnackBar
          message={StateData.message}
          variant={StateData.variant}
          open={StateData.open}
          handleClose={() => {
            SetStateData((prevState: any) => {
              return { ...prevState, open: false };
            });
          }}
        />
      </ContentStyle>
    </>
  );
}
